<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { NativeSelect } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalDisciplineSchedulePace } from '../../model/modal-discipline-schedule-pace.hook'

defineOptions({
  name: 'ModalDisciplineSchedulePace',
})

const {
  refOptions,
  refValue,
  refIsEditable,
  refHasWarning,
  refIsDisabled,
  setPace,
  close,
  back,
  confirm,
} = useModalDisciplineSchedulePace()
</script>

<template>
  <ModalDefault
    show
    title="Set learning pace"
    class-name="modal-discipline-schedule-step"
    is-close-button
    is-back-button
    @click:overlay="close"
    @click:close="close"
    @click:back="back"
  >
    <div class="modal-discipline-schedule-pace">
      <NativeSelect
        name="pace"
        label="Learning pace"
        :options="refOptions"
        :value="refValue"
        :disabled="!refIsEditable"
        @change="setPace"
      />
      <AppText
        v-if="refHasWarning"
        name="body2"
        class="modal-discipline-schedule-pace__warning"
      >
        ⚠️ Please select at least 1 lesson per week to continue
      </AppText>
    </div>
    <template #controls>
      <BtnPrimary
        text="Continue"
        color="emerald"
        :disabled="refIsDisabled"
        @click="confirm"
      />
      <BtnSecondary
        text="Cancel"
        color="black"
        @click="close"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineSchedule.scss" />
<style scoped lang="scss" src="./ModalDisciplineSchedulePace.scss" />
